import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Tooltip } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import cx from 'classnames';
import messages from './CommonQuoteInfo.messages';
import commonQuoteStyles from '../../quoteandbind-common-styles.module.scss';

import { Link } from '@jutro/router';

function CommonQuoteInfo(props) {
    const { submissionVM } = props;
    const translator = useTranslator();
    const breakpoint = useContext(BreakpointTrackerContext);
    const quoteId = _.get(submissionVM, 'quoteID.value');
    const location = _.get(submissionVM, 'baseData.policyAddress.displayName.value');
    const accountName = _.get(submissionVM, 'baseData.accountHolder.displayName.value');
    const accountLink = `/accounts/${_.get(submissionVM.value,'baseData.accountNumber')}/summary`;
   
    if (breakpoint === 'phoneWide' || breakpoint === 'phone') {
        return (
            <div className={commonQuoteStyles.quoteInfoBar}>
                <div className={commonQuoteStyles.infoBlock}>
                    <div className={commonQuoteStyles.infoBlockTitle}>
                        {translator(messages.quote)}
                    </div>
                    <div id="contextSubmissionId" className={commonQuoteStyles.infoBlockContent}>
                        {quoteId}
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div className={commonQuoteStyles.quoteInfoBar}>
            <div className={commonQuoteStyles.quoteWrapper}>
            <div className={commonQuoteStyles.infoBlock}>
                    <div className={commonQuoteStyles.infoBlockTitle}>{translator(messages.account)}</div>
                    <Link className={commonQuoteStyles.infoBlockContent} to={accountLink}>
                        {accountName}
                    </Link>
                </div>
                <div className={commonQuoteStyles.infoBlock}>
                    <div className={commonQuoteStyles.infoBlockTitle}>{translator(messages.quote)}</div>
                    <div id="contextSubmissionId" className={commonQuoteStyles.infoBlockContent}>
                        {quoteId}
                    </div>
                </div>
                <div className={commonQuoteStyles.infoBlock}>
                    <div className={commonQuoteStyles.infoBlockTitle}>
                        {translator(messages.location)}
                    </div>
                    <div id="contextLocation" className={commonQuoteStyles.infoBlockContent}>
                        <Tooltip
                            id="policyLocation"
                            placement="bottom"
                            trigger="mouseenter"
                            content={location}
                        >
                            <div className={commonQuoteStyles.infoOverflow}>{location}</div>
                        </Tooltip>
                    </div>
                </div>
            </div>
        </div>
    );
}

CommonQuoteInfo.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired
};

export default CommonQuoteInfo;
